import type { ScenarioProjection } from '../domain/types';
import { SourceFields } from './ScenarioEntryInspector';
export function ScenarioSourceInspector({ data }: { readonly data: ScenarioProjection }) {
  return (
    <details className="scc-source">
      <summary>来源、完整 pin 与技术验证局限</summary>
      <h3>ScenarioTemplate exact source pin</h3>
      <SourceFields value={{ ...data.provenance.pin }} />
      <p>Git {data.provenance.frozenCommit}</p>
      <p>Source path {data.provenance.sourcePath}</p>
      <SourceFields value={{ ...data.provenance.sourceBlobs }} />
      <p>
        {data.provenance.mode} · {data.provenance.formation} · {data.provenance.lifecycle}
      </p>
      <p>形成证据 {data.provenance.formationRecord}</p>
      <SourceFields value={data.provenance.limits} />
      <h3>Manifest exact documentary pin</h3>
      <SourceFields value={{ ...data.provenance.manifestPin }} />
      <details>
        <summary>完整源语义：范围、进入意义、预防、复盘与边界</summary>
        <SourceFields value={data.body} />
      </details>
    </details>
  );
}
